import React, { useState } from 'react';
import DisplayTemplate from '../displayTemplate';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Menu, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    imageContainer: {
        height: '400px',
        width: '500px',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    imageLoadingContainer: {
        height: 'auto',
    },
}));

export default function Image({
    contentType,
    content,
    contentDisplayType,
    contentUrl,
    mediaStyle,
    overrideHTML,
    renderDefault = false,
    helpText,
    templateType,
    ...props
}) {
    const theme = useTheme();
    const { classes } = useStyles();
    const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
    const [imageLoading, setImageLoading] = useState(true);
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [menuAnchorPosition, setMenuAnchorPosition] = useState(null);

    const handleImagePreviewClose = () => {
        setImagePreviewUrl(null);
    };

    const handleRightClick = (event) => {
        event.preventDefault(); // Prevent the browser's default context menu
        setMenuAnchor(event.currentTarget);
        setMenuAnchorPosition({
            top: event.clientY,
            left: event.clientX,
        });
    };

    const handleMenuOpen = (event) => {
        setMenuAnchor(event.currentTarget);
        setMenuAnchorPosition({
            top: event.clientY,
            left: event.clientX,
        });
    };

    const handleMenuClose = () => {
        setMenuAnchor(null);
        setMenuAnchorPosition(null);
    };

    const handleViewImage = () => {
        setImagePreviewUrl(contentUrl);
        handleMenuClose();
    };

    const Component = () => (
        <>
            <Box
                component="img"
                sx={{
                    borderRadius: '5px',
                    height: props.quizPart ? '70px' : props?.mtf ? '70px' : '150px',
                    width: props.quizPart ? 'auto' : props?.mtf ? 'auto' : '100%',
                    maxWidth: '100%',
                    ...mediaStyle,
                    [theme.breakpoints.down('sm')]: {
                        height: '100px',
                        width: '80%',
                    },
                }}
                onMouseEnter={handleMenuOpen}
                onMouseLeave={handleMenuClose}
                // onContextMenu={handleRightClick}
                // onClick={() => setImagePreviewUrl(contentUrl)}
                src={contentUrl}
                alt="picture quiz"
            />
            {props?.mtf && <Menu
                anchorEl={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={handleMenuClose}
                anchorReference="anchorPosition"
                anchorPosition={
                    menuAnchorPosition
                        ? { top: menuAnchorPosition.top, left: menuAnchorPosition.left }
                        : undefined
                }
            >
                <MenuItem onClick={handleViewImage}>View Image</MenuItem>
            </Menu>
            }
            {props?.mtf &&
                <Dialog open={Boolean(imagePreviewUrl)} onClose={handleImagePreviewClose}>
                    <DialogTitle>Image Preview</DialogTitle>
                    <DialogContent className={classes.imageContainer}>
                        {imageLoading && <Box className={classes.imageLoadingContainer}>
                            <CircularProgress />
                        </Box>}
                        {imagePreviewUrl && (
                            <img
                                src={imagePreviewUrl}
                                alt="Preview"
                                style={{ height: '100%' }}
                                onLoad={() => setImageLoading(false)}
                                onLoadStart={() => setImageLoading(true)}
                            />
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleImagePreviewClose}>Close</Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    );
    return renderDefault ? <Component /> : <DisplayTemplate templateType={templateType} components={[Component]} {...props} />;
}
